import React from "react";
import fakeNewsService from "../services/fakeNewsService";
import ContentBlockquote from './StateLessComponents/ContentBlockquote';
import fakeContentService from '../services/fakeContentService';

class NewsComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            content: null,
            news: []
        };
    }

    async componentDidMount() {
        const news = await fakeNewsService.getNews();
        const content = await fakeContentService.getNewsContent()

        if (news) this.setState({ content, news });
    }

    render() {
        const { content, news } = this.state;

        return (
            <blockquote className="kgnsf-blockquote">
                <h2 className="kgnsf-header center">Veranstaltungen</h2>
                <ContentBlockquote content={content}></ContentBlockquote>
                <ul className="list-group">
                    {news?.map((article, index) => {
                        return (
                            <li className="list-group-item" key={index}>
                                <h4>{article.title}</h4>
                                <div className="row">
                                    {article.image && <div className="col-md-4 col-lg-4 col-sm-12">
                                        <img alt="" className="img-fluid" src={article.image} />
                                    </div>}
                                    <div className="col kgnsf-content">
                                        {article.content}
                                    </div>
                                </div>
                                {article.files && article.files.map((file, index) => {
                                    return (<a className="btn btn-danger end" href={file.src} key={file.title + index} target="_blank" rel="noreferrer">
                                        <i className="bi bi-download"></i> {file.title}
                                    </a>)
                                })}
                            </li>
                        )
                    })}
                </ul>
            </blockquote>
        );
    }
}

export default NewsComponent;